import { render } from "./EscritorioServicios.vue?vue&type=template&id=55d0e624"
import script from "./EscritorioServicios.vue?vue&type=script&lang=js"
export * from "./EscritorioServicios.vue?vue&type=script&lang=js"

import "./EscritorioServicios.vue?vue&type=style&index=0&id=55d0e624&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__